export const esmx = {
  translation: {
    // Login
    "login_page_title": "InteliQR Menú",
    "login_page_subtitle": "Inicie sesión para acceder a su panel",
    "login_form_signin_google_button": "Sign In",
    "login_form_divider_options": "Ó",
    "login_form_email": "Correo electrónico",
    "login_form_password": "Contraseña",
    "login_form_button": "Iniciar Sesión",
    // Register
    "register_page_title": "Crea tu cuenta",
    "register_page_subtitle": "Construye tu menú",
    "register_form_company": "Nombre de tu compania",
    "register_form_signin_google_button": "Sign Up",
    "register_form_divider_options": "Ó",
    "register_form_email": "Correo electrónico",
    "register_form_password": "Contraseña",
    "register_form_button": "Crear cuenta",
    "register_already_account_text": "¿Tienes una cuenta",
    "register_already_account_button": "Accesa",
    //
    "cancelar": "Cancelar",
    "bienvenido": "Bienvenido",
    "mensaje_bienvenida": "Aqui podrás administrar todo los relacionado a los menús de tu empresa",
    //branch office
    "branchoffice_page_title": "Sucursales",
    "branchoffice_page_add_button_text": "Agregar",
    "branchoffice_page_edit_button_text": "Editar",
    "branchoffice_page_delete_button_text": "Eliminar",
    "branchoffice_search_placeholder_text": "Buscar",
    "branchoffice_card_name": "Nombre / Razón Social",
    "branchoffice_card_address": "Dirección (calle y número)",
    "branchoffice_card_city": "Ciudad",
    "branchoffice_card_state": "Estado",
    "branchoffice_card_postalcode": "Código postal",
    "branchoffice_card_phone": "Teléfono (fijo)",
    "branchoffice_card_cellphone": "Teléfono (móvil - whatsapp)",
    "branchoffice_card_email": "Correo electrónico",
    "branchoffice_dialog_title_add": "Agregar sucursal",
    "branchoffice_dialog_title_edit": "Editar sucursal",
    "branchoffice_dialog_title_delete": "Eliminar sucursal",
    "branchoffice_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar la sucursal {{name}}?",
    "branchoffice_form_name": "Nombre",
    "branchoffice_form_address": "Dirección",
    "branchoffice_form_city": "Ciudad",
    "branchoffice_form_state": "Estado",
    "branchoffice_form_zip_code": "Código Postal",
    "branchoffice_form_phone": "Teléfono",
    "branchoffice_form_whatsapp": "Whatsapp",
    "branchoffice_form_email": "Correo electrónico",
    "branchoffice_form_logo": "Logotipo",
    "branchoffice_form_active": "Activar",
    //users
    "users_page_title": "Usuarios",
    "users_search_placeholder_text": "Buscar",
    "users_table_name_column": "Nombre",
    "users_table_email_column": "Correo electrónico",
    "users_table_role_column": "Rol",
    "users_table_actions_column": "Acciones",
    "users_dialog_title_add": "Agregar usuario",
    "users_dialog_title_edit": "Editar usuario",
    "users_dialog_title_permission": "Permisos del usuario",
    "users_dialog_title_delete": "Eliminar usuario",
    "users_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar el usuario {{name}}?",
    "users_form_name": "Nombre",
    "users_form_phone": "Teléfono",
    "users_form_email": "Correo electrónico",
    "users_form_password": "Contraseña",
    "users_form_role": "Rol de usuario",
    "users_form_branch_office": "Sucursal",
    "users_form_active": "Activar",
    //menus
    "menu_page_title": "Menus",
    "menu_page_add_button_text": "Agregar",
    "menu_page_edit_button_text": "Editar",
    "menu_page_delete_button_text": "Eliminar",
    "menu_page_show_menu_button_text": "Ver menú",
    "menu_search_placeholder_text": "Buscar",
    "menu_table_name_column": "Nombre",
    "menu_table_description_column": "Descripción",
    "menu_table_actions_column": "Acciones",
    "menu_dialog_title_add": "Agregar menú",
    "menu_dialog_title_edit": "Editar menú",
    "menu_dialog_title_delete": "Eliminar menú",
    "menu_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar el menú {{name}}?",
    "menu_form_name": "Nombre",
    "menu_form_description": "Descripción",
    "menu_form_branch_office": "Sucursal",
    "menu_form_active": "Activar",
    //menu design
    "designmenu_page_title": "Diseño de menú",
    "designmenu_menu_design_text": "Menú de Diseño",
    "designmenu_select_options_placeholder": "Selección de opciones",
    "designmenu_select_option_options": "Opciones",
    "designmenu_select_option_general_features": "Aspecto General",
    "designmenu_select_option_header": "Cabecera",
    "designmenu_select_option_navigation_menu": "Menú de Navegación",
    "designmenu_select_option_separators": "Separadores",
    "designmenu_select_option_typography": "Tipografía",
    "designmenu_select_option_layout": "Plantillas",
    "designmenu_general_features_form_base_color": "Color base",
    "designmenu_general_features_form_base_color_tooltip": "Color base",
    "designmenu_general_features_form_tipography_name": "Nombre de la tipografía general",
    "designmenu_general_features_form_tipography_name_tooltip": "Nombre de la tipografía general",
    "designmenu_general_features_form_tipography_url": "Url de la tipografía general",
    "designmenu_general_features_form_tipography_google": "Fuente de Goole Fonts",
    "designmenu_general_features_form_tipography_url_tooltip": "Url de la tipografía general",
    "designmenu_general_features_form_tipography_color": "Color de la tipografía",
    "designmenu_general_features_form_tipography_color_tooltip": "Color de la tipografía",
    "designmenu_general_features_form_background_image": "Imagen de Fondo",
    "designmenu_general_features_form_background_image_tooltip": "Imagen de Fondo",
    "designmenu_header_form_background_color": "Color de fondo",
    "designmenu_header_form_background_color_tooltip": "Color de fondo",
    "designmenu_header_form_background_image": "Imagen de fondo",
    "designmenu_header_form_background_image_tooltip": "Imagen de fondo",
    "designmenu_navigation_menu_form_tipography_name": "Nombre de la tipografía general",
    "designmenu_navigation_menu_form_tipography_name_tooltip": "Nombre de la tipografía general",
    "designmenu_navigation_menu_form_tipography_url": "Url de la tipografía general",
    "designmenu_navigation_menu_form_tipography_url_tooltip": "Url de la tipografía general",
    "designmenu_navigation_menu_form_same_tipography": "Misma tipografía que la dada general",
    "designmenu_navigation_menu_form_same_tipography_tooltip": "Misma tipografía que la dada general",
    "designmenu_navigation_menu_form_tipography_color": "Color de la tipografía",
    "designmenu_navigation_menu_form_tipography_color_tooltip": "Color de la tipografía",
    "designmenu_navigation_menu_form_text_size_pc": "Tamaño del texto para PC",
    "designmenu_navigation_menu_form_text_size_pc_tooltip": "Tamaño del texto para PC",
    "designmenu_navigation_menu_form_text_size_mobil": "Tamaño del texto para Móvil",
    "designmenu_navigation_menu_form_text_size_mobil_tooltip": "Tamaño del texto para Móvil",
    "designmenu_navigation_menu_form_background_image": "Imagen de Fondo",
    "designmenu_navigation_menu_form_background_image_tooltip": "Imagen de Fondo",
    "designmenu_navigation_menu_form_active_category_color": "Color indicativo de categoría activa",
    "designmenu_navigation_menu_form_active_category_color_tooltip": "Color indicativo de categoría activa",
    "designmenu_navigation_menu_form_arrows_color": "Color flechas de navegación",
    "designmenu_navigation_menu_form_arrows_color_tooltip": "Color flechas de navegación",
    "designmenu_navigation_menu_form_dots_color": "Color puntos de navegación",
    "designmenu_navigation_menu_form_dots_color_tooltip": "Color puntos de navegación",
    "designmenu_separators_form_size": "Tamaño / Altura de separadores",
    "designmenu_separators_form_size_tooltip": "Tamaño / Altura de separadores",
    "designmenu_separators_form_color": "Color / Gradiente de separadores",
    "designmenu_separators_form_color_tooltip": "Color / Gradiente de separadores",
    "designmenu_typography_form_category_section": "Categorías",
    "designmenu_typography_form_category_name_size": "Nombre de la categoría",
    "designmenu_typography_form_category_name_size_tooltip": "Nombre de la categoría",
    "designmenu_typography_form_category_description_size": "Descripción de la categoría",
    "designmenu_typography_form_category_description_size_tooltip": "Descripción de la categoría",
    "designmenu_typography_form_category_footer_size": "Pie de categoría",
    "designmenu_typography_form_category_footer_size_tooltip": "Pie de categoría",
    "designmenu_typography_form_subcategory_section": "Subcategorías",
    "designmenu_typography_form_subcategory_name_size": "Nombre de la subcategoría",
    "designmenu_typography_form_subcategory_name_size_tooltip": "Nombre de la subcategoría",
    "designmenu_typography_form_subcategory_description_size": "Descripción de la subcategoría",
    "designmenu_typography_form_subcategory_description_size_tooltip": "Descripción de la subcategoría",
    "designmenu_typography_form_subcategory_footer_size": "Pie de subcategoría",
    "designmenu_typography_form_subcategory_footer_size_tooltip": "Pie de subcategoría",
    "designmenu_typography_form_product_section": "Productos",
    "designmenu_typography_form_product_name_size": "Nombre del producto",
    "designmenu_typography_form_product_name_size_tooltip": "Nombre del producto",
    "designmenu_typography_form_product_description_size": "Descripción del producto",
    "designmenu_typography_form_product_description_size_tooltip": "Descripción del producto",
    "designmenu_typography_form_variant_name_size": "Nombre de la variante del producto",
    "designmenu_typography_form_variant_name_size_tooltip": "Nombre de la variante del producto",
    "designmenu_typography_form_variant_description_size": "Descripción de la variante del producto",
    "designmenu_typography_form_variant_description_size_tooltip": "Descripción de la variante del producto",
    "designmenu_typography_form_variant_price_size": "Precio de la variante del producto",
    "designmenu_typography_form_variant_price_size_tooltip": "Precio de la variante del producto",
    //product tags
    "producttags_page_title": "Etiquetas de producto",
    "producttags_page_add_button_text": "Agregar",
    "producttags_page_edit_button_text": "Editar",
    "producttags_page_delete_button_text": "Eliminar",
    "producttags_search_placeholder_text": "Buscar",
    "producttags_table_name_column": "Nombre",
    "producttags_table_actions_column": "Acciones",
    "producttags_dialog_title_add": "Agregar etiqueta",
    "producttags_dialog_title_edit": "Editar etiqueta",
    "producttags_dialog_title_delete": "Eliminar etiqueta",
    "producttags_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar la etiqueta {{name}}?",
    "producttags_form_name": "Nombre",
    "producttags_form_textcolor": "Color del texto",
    "producttags_form_backgroundcolor": "Color del fondo",
    "producttags_form_active": "Activar",
    //promotions tags
    "promotions_page_title": "Promociones",
    "promotions_page_add_button_text": "Agregar",
    "promotions_page_edit_button_text": "Editar",
    "promotions_page_delete_button_text": "Eliminar",
    "promotions_page_show_button_text": "Ver promoción",
    "promotions_page_copy_button_text": "Copiar",
    "promotions_search_placeholder_text": "Buscar",
    "promotions_page_change_menu_button_text": "Cambiar de menu",
    "promotions_table_name_column": "Nombre",
    "promotions_table_validity_column": "Vigencia",
    "promotions_table_actions_column": "Acciones",
    "promotions_dialog_title_add": "Agregar promoción",
    "promotions_dialog_title_edit": "Editar promoción",
    "promotions_dialog_title_delete": "Eliminar promoción",
    "promotions_dialog_title_copy": "Copiar promoción",
    "promotions_dialog_instrucions_copy_text": "Selecciona el/los menus en los cuales se requiera copiar la promoción",
    "promotions_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar la promoción {{name}}?",
    "promotions_form_name": "Nombre",
    "promotions_form_description": "Descripción",
    "promotions_form_image": "Imagen",
    "promotions_form_duration": "Duración",
    "promotions_form_validity_start": "Vigencia - Hora y fecha de inicio",
    "promotions_form_validity_end": "Vigencia - Hora y fecha de termino",
    "promotions_form_active": "Activar",

    //Builder
    "builder_page_title": "Categorías y Subcategorías",
    "builder_page_instructions": "Menú al que se le agregarán categorías, subcategorías y productos",
    "builder_page_menu_select_label": "Selección",
    //Builder Fast Menu
    "builder_bulkload_dialog_title": "Creación Rápida de Menú",
    "builder_bulkload_dialog_description_categories": "Pega una lista de categorías separadas por salto de línea",
    "builder_bulkload_dialog_label_categories_textarea": "Categorías",
    "builder_bulkload_dialog_description_subcategories": "Pega una lista de subcategorías separadas por salto de línea por cada una de las categorías anteriores. Si no deseas agregar subcategorías a una categoría, deja el campo con el valor Default.",
    "builder_bulkload_dialog_description_products": "Pega una lista de productos separados por salto de línea por cada una de las subcategorías anteriores. Cada campo es obligatorio",
    //Builder Categories
    "builder_categories_title": "Categorías",
    "builder_categories_dialog_title_add": "Agregar categoría",
    "builder_categories_dialog_title_edit": "Editar categoría",
    "builder_categories_dialog_title_delete": "Eliminar categoría",
    "builder_categories_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar la categoría {{name}}?",
    "builder_categories_form_name": "Nombre",
    "builder_categories_form_show_name": "Mostrar nombre",
    "builder_categories_form_description": "Descripción",
    "builder_categories_form_footer": "Texto al pie de la categoría",
    "builder_categories_form_image": "Ícono inactivo del menú de navegación",
    "builder_categories_form_image_active": "Ícono activo del menú de navegación",
    "builder_categories_form_show_image": "Mostrar ícono",
    "builder_categories_form_header_image": "Imagen de cabecera",
    "builder_categories_form_show_header_image": "Mostrar imagen de cabecera",
    "builder_categories_form_active": "Activar",
    //Builder Subcategories
    "builder_subcategories_title": "Subcategorías",
    "builder_subcategories_dialog_title_add": "Agregar subcategoría",
    "builder_subcategories_dialog_title_edit": "Editar subcategoría",
    "builder_subcategories_dialog_title_delete": "Eliminar subcategoría",
    "builder_subcategories_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar la subcategoría {{name}}?",
    "builder_subcategories_form_name": "Nombre",
    "builder_subcategories_form_show_name": "Mostrar nombre",
    "builder_subcategories_form_description": "Descripción",
    "builder_subcategories_form_footer": "Texto al pie de la subcategoría",
    "builder_subcategories_form_image": "Imagen",
    "builder_subcategories_form_show_image": "Mostrar imagen",
    "builder_subcategories_form_presentation": "Tipo de presentación",
    "builder_subcategories_form_active": "Activar",
    "builder_subcategories_dialog_title_columns": "Columnas",
    "builder_subcategories_dialog_columns_iconcolor": "Color de los iconos",
    "builder_subcategories_dialog_columns_iconlist": "Lista de íconos",
    "builder_subcategories_dialog_columns_icon": "Ícono",
    "builder_subcategories_dialog_columns_name": "Nombre",
    "builder_subcategories_dialog_columns_show": "Mostrar",
    "builder_subcategories_dialog_columns_instructions": "Todos los campos deben estar llenos y los iconos seleccioandos",
    // Qr code
    "qrcode_page_title": "Códigos Qr",
    "qrcode_page_add_button_text": "Agregar",
    "qrcode_page_edit_button_text": "Editar",
    "qrcode_page_delete_button_text": "Eliminar",
    "qrcode_page_style_button_text": "Estilo",
    "qrcode_search_placeholder_text": "Buscar",
    "qrcode_table_name_column": "Nombre",
    "qrcode_table_branchoffice_column": "Sucursal",
    "qrcode_table_menu_column": "Menú",
    "qrcode_table_actions_column": "Acciones",
    "qrcode_dialog_title_add": "Agregar codigo qr",
    "qrcode_dialog_title_edit": "Editar codigo qr",
    "qrcode_dialog_title_style": "Editar estilos codigo qr",
    "qrcode_dialog_title_delete": "Eliminar codigo qr",
    "qrcode_dialog_confirm_delete_text": "¿Estas seguro de querer eliminar el codigo qr {{name}}?",
    "qrcode_form_name": "Nombre",
    "qrcode_form_description": "Descripción",
    "qrcode_form_branch_office": "Sucursal",
    "qrcode_form_menu": "Menú",
    "qrcode_form_active": "Activar",
    "qrcode_style_form_size": "Tamaño del QR",
    "qrcode_style_form_margin": "Margen",
    "qrcode_style_form_image": "Imagen central",
    "qrcode_style_form_background": "Color de fondo",
    "qrcode_style_form_points_style": "Estilos de puntos",
    "qrcode_style_form_points_color": "Color de puntos",
    "qrcode_style_form_corners_square_style": "Estilo de los cuadrados en la esquina",
    "qrcode_style_form_corners_square_color": "Color de los cuadrados en la esquina",
    "qrcode_style_form_corners_dot_style": "Estilo de los puntos dentro de los cuadrados en la esquina",
    "qrcode_style_form_corners_dot_color": "Color de los puntos dentro de los cuadrados en la esquina",

    //Validaciones
    "required": "Requerido",

    //Buttons text
    "button_text_save": "Guardar",
    "button_text_add": "Agregar",
    "button_text_edit": "Editar",
    "button_text_delete": "Eliminar",
    "button_text_cancel": "Cancelar",
    "button_text_copy": "Copiar",
    "button_text_move": "Mover",
    "button_text_columns": "Columnas",

    //Menu Drawer
    "menu_drawer_text_dashboard": "Dashboard",
    "menu_drawer_text_branchoffices": "Sucursales",
    "menu_drawer_text_users": "Usuarios",
    "menu_drawer_text_menus": "Menús",
    "menu_drawer_text_design": "Diseño",
    "menu_drawer_text_builder": "Categorías & Sub",
    "menu_drawer_text_labels": "Etiquetas",
    "menu_drawer_text_promotions": "Promociones",
    "menu_drawer_text_qrcode": "Códigos QR",
    "menu_drawer_text_pricing": "Suscripciones",

    //MUIDataTable
    "muidt_body_no_match": "No se encontraron registros",
    "muidt_body_tooltip_order": "Ordenar",
    "muidt_body_custom_tooltip_order": "Ordenar por",
    "muidt_pagination_next": "Siguiente",
    "muidt_pagination_previous": "Anterior",
    "muidt_pagination_rowsperpage": "Filas por página:",
    "muidt_pagination_displayrows": "de",
    "muidt_toolbar_search": "Buscar",
    "muidt_toolbar_downloadcsv": "Descargar CSV",
    "muidt_toolbar_print": "Imprimir",
    "muidt_toolbar_viewcolumns": "Ver columnas",
    "muidt_toolbar_filtertable": "Filtros de tabla",
    "muidt_filter_all": "Todos",
    "muidt_filter_title": "Filtros",
    "muidt_filter_reset": "Reiniciar",
    "muidt_viewcolumnas_title": "Mostrar columnas",
    "muidt_viewcolumnas_titlearia": "Mostrar/Ocultar columnas",
    "muidt_selectedrows_text": "fila(s) seleccionadas",
    "muidt_selectedrows_delete": "Eliminar",
    "muidt_selectedrows_deletearia": "Eliminar filas seleccionadas",
  }
}